module.exports = __webpack_public_path__ + "img/icon-device.fd288cca.svg";